var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.429688C1.48122 0.429688 0.25 1.6609 0.25 3.17969V18.3181C0.25 19.2778 1.28684 19.8796 2.12021 19.4033L7.37975 16.3979C7.76407 16.1784 8.23587 16.1783 8.62019 16.3979L13.8798 19.4034C14.7132 19.8795 15.75 19.2779 15.75 18.3181V3.17969C15.75 1.66091 14.5188 0.429688 13 0.429688H3ZM1.75 3.17969C1.75 2.48933 2.30964 1.92969 3 1.92969H13C13.6904 1.92969 14.25 2.48932 14.25 3.17969V17.8873L9.36441 15.0955C8.51896 14.6125 7.4811 14.6125 6.63565 15.0955L1.75 17.8873V3.17969Z",
    fill: "#051123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkBlack);
export default __webpack_public_path__ + "static/media/bookmark_black.0cda0eae58fe4c13bddb0ffbe19ae6f8.svg";
export { ForwardRef as ReactComponent };